import { Action } from '@ngrx/store';
import { Lookup, AccessCardType, User } from '@app/core';

export enum LookupActionTypes {
  LoadCountries = '[Lookup] Load Countries',
  LoadCountriesSuccess = '[Lookup] Load Countries Success',
  LoadCountriesFail = '[Lookup] Load Countries Fail',

  LoadContactTypes = '[Lookup] Load ContactTypes',
  LoadContactTypesSuccess = '[Lookup] Load ContactTypes Success',
  LoadContactTypesFail = '[Lookup] Load ContactTypes Fail',

  LoadLicenseTypes = '[Lookup] Load License Types',
  LoadLicenseTypesSuccess = '[Lookup] Load License Types Success',
  LoadLicenseTypesFail = '[Lookup] Load License Types Fail',

  LoadIDTypes = '[Lookup] Load ID Types',
  LoadIDTypesSuccess = '[Lookup] Load ID Types Success',
  LoadIDTypesFail = '[Lookup] Load ID Types Fail',

  LoadVenueTypes = '[Lookup] Load Venue Types',
  LoadVenueTypesSuccess = '[Lookup] Load Venue Types Success',
  LoadVenueTypesFail = '[Lookup] Load Venue Types Fail',

  LoadAccessCardTypes = '[Lookup] Load Access Card Types',
  LoadAccessCardTypesSuccess = '[Lookup] Load Access Card Types Success',
  LoadAccessCardTypesFail = '[Lookup] Load Access Card Types Fail',

  LoadRequestAccessCardReasons = '[Lookup] Load Request Access CardReason',
  LoadRequestAccessCardReasonsSuccess = '[Lookup] Load Request Access Card Reason',
  LoadRequestAccessCardReasonsFail = '[Lookup] Load Request Access Card Reason Fail',


  LoadChargeTypes = '[Lookup] Load Charge Types',
  LoadChargeTypesSuccess = '[Lookup] Load Charge Types Success',
  LoadChargeTypesFail = '[Lookup] Load Charge Types Fail',

  LoadUsers = '[Lookup] Load Users',
  LoadUsersSuccess = '[Lookup] Load Users Success',
  LoadUsersFail = '[Lookup] Load Users Fail',

  LoadAccessCardCancellationReason = '[Lookup] Load AccessCardCancellationReason',
  LoadAccessCardCancellationReasonSuccess = '[Lookup] Load AccessCardCancellationReason Success',
  LoadAccessCardCancellationReasonFail = '[Lookup] Load AccessCardCancellationReason Fail',

  LoadRequestStatus = '[Lookup] Load Request Status',
  LoadRequestStatusSuccess = '[Lookup] Load Request Status Success',
  LoadRequestStatusFail = '[Lookup] Load Request Status Fail',
}

export class LoadCountries implements Action {
  readonly type = LookupActionTypes.LoadCountries;
}

export class LoadCountriesFail implements Action {
  readonly type = LookupActionTypes.LoadCountriesFail;
  constructor(public payload: any) { }
}

export class LoadCountriesSuccess implements Action {
  readonly type = LookupActionTypes.LoadCountriesSuccess;
  constructor(public payload: Lookup[]) { }
}


export class LoadContactTypes implements Action {
  readonly type = LookupActionTypes.LoadContactTypes;
}

export class LoadContactTypesFail implements Action {
  readonly type = LookupActionTypes.LoadContactTypesFail;
  constructor(public payload: any) { }
}

export class LoadContactTypesSuccess implements Action {
  readonly type = LookupActionTypes.LoadContactTypesSuccess;
  constructor(public payload: Lookup[]) { }
}

export class LoadLicenseTypes implements Action {
  readonly type = LookupActionTypes.LoadLicenseTypes;
}

export class LoadLicenseTypesFail implements Action {
  readonly type = LookupActionTypes.LoadLicenseTypesFail;
  constructor(public payload: any) { }
}

export class LoadLicenseTypesSuccess implements Action {
  readonly type = LookupActionTypes.LoadLicenseTypesSuccess;
  constructor(public payload: Lookup[]) { }
}

export class LoadIDTypes implements Action {
  readonly type = LookupActionTypes.LoadIDTypes;
}

export class LoadIDTypesFail implements Action {
  readonly type = LookupActionTypes.LoadIDTypesFail;
  constructor(public payload: any) { }
}

export class LoadIDTypesSuccess implements Action {
  readonly type = LookupActionTypes.LoadIDTypesSuccess;
  constructor(public payload: Lookup[]) { }
}

export class LoadVenueTypes implements Action {
  readonly type = LookupActionTypes.LoadVenueTypes;
}

export class LoadVenueTypesFail implements Action {
  readonly type = LookupActionTypes.LoadVenueTypesFail;
  constructor(public payload: any) { }
}

export class LoadVenueTypesSuccess implements Action {
  readonly type = LookupActionTypes.LoadVenueTypesSuccess;
  constructor(public payload: Lookup[]) { }
}

export class LoadAccessCardTypes implements Action {
  readonly type = LookupActionTypes.LoadAccessCardTypes;
}

export class LoadAccessCardTypesFail implements Action {
  readonly type = LookupActionTypes.LoadAccessCardTypesFail;
  constructor(public payload: any) { }
}

export class LoadAccessCardTypesSuccess implements Action {
  readonly type = LookupActionTypes.LoadAccessCardTypesSuccess;
  constructor(public payload: AccessCardType[]) { }
}


export class LoadRequestAccessCardReasons implements Action {
  readonly type = LookupActionTypes.LoadRequestAccessCardReasons;
}

export class LoadRequestAccessCardReasonsFail implements Action {
  readonly type = LookupActionTypes.LoadRequestAccessCardReasonsFail;
  constructor(public payload: any) { }
}

export class LoadRequestAccessCardReasonsSuccess implements Action {
  readonly type = LookupActionTypes.LoadRequestAccessCardReasonsSuccess;
  constructor(public payload: Lookup[]) { }
}

export class LoadChargeTypes implements Action {
  readonly type = LookupActionTypes.LoadChargeTypes;
  constructor(public payload: number) { }
}

export class LoadChargeTypesFail implements Action {
  readonly type = LookupActionTypes.LoadChargeTypesFail;
  constructor(public payload: any) { }
}

export class LoadChargeTypesSuccess implements Action {
  readonly type = LookupActionTypes.LoadChargeTypesSuccess;
  constructor(public payload: Lookup[]) { }
}

export class LoadUsers implements Action {
  readonly type = LookupActionTypes.LoadUsers;
}

export class LoadUsersFail implements Action {
  readonly type = LookupActionTypes.LoadUsersFail;
  constructor(public payload: any) { }
}

export class LoadUsersSuccess implements Action {
  readonly type = LookupActionTypes.LoadUsersSuccess;
  constructor(public payload: User[]) { }
}

export class LoadAccessCardCancellationReason implements Action {
  readonly type = LookupActionTypes.LoadAccessCardCancellationReason;
}

export class LoadAccessCardCancellationReasonFail implements Action {
  readonly type = LookupActionTypes.LoadAccessCardCancellationReasonFail;
  constructor(public payload: any) { }
}

export class LoadAccessCardCancellationReasonSuccess implements Action {
  readonly type = LookupActionTypes.LoadAccessCardCancellationReasonSuccess;
  constructor(public payload: Lookup[]) { }
}



export class LoadRequestStatus implements Action {
  readonly type = LookupActionTypes.LoadRequestStatus;
}

export class LoadRequestStatusFail implements Action {
  readonly type = LookupActionTypes.LoadRequestStatusFail;
  constructor(public payload: any) { }
}

export class LoadRequestStatusSuccess implements Action {
  readonly type = LookupActionTypes.LoadRequestStatusSuccess;
  constructor(public payload: Lookup[]) { }
}


export type LookupAction =
  | LoadCountries
  | LoadCountriesFail
  | LoadCountriesSuccess

  | LoadContactTypes
  | LoadContactTypesFail
  | LoadContactTypesSuccess

  | LoadLicenseTypes
  | LoadLicenseTypesFail
  | LoadLicenseTypesSuccess

  | LoadIDTypes
  | LoadIDTypesFail
  | LoadIDTypesSuccess

  | LoadVenueTypes
  | LoadVenueTypesFail
  | LoadVenueTypesSuccess

  | LoadAccessCardTypes
  | LoadAccessCardTypesFail
  | LoadAccessCardTypesSuccess

  | LoadRequestAccessCardReasons
  | LoadRequestAccessCardReasonsFail
  | LoadRequestAccessCardReasonsSuccess

  | LoadChargeTypes
  | LoadChargeTypesFail
  | LoadChargeTypesSuccess

  | LoadUsers
  | LoadUsersFail
  | LoadUsersSuccess

  | LoadAccessCardCancellationReason
  | LoadAccessCardCancellationReasonFail
  | LoadAccessCardCancellationReasonSuccess

  | LoadRequestStatus
  | LoadRequestStatusSuccess
  | LoadRequestStatusFail
  ;




// WEBPACK FOOTER //
// ./src/app/core/store/actions/lookup.actions.ts